import { PublicSiteSettings } from '@data/sanity/queries/types/site'
import { customAlphabet } from 'nanoid'
import Script from 'next/script'
import { useMemo } from 'react'

interface ExternalScriptsProps {
  publicSettings?: PublicSiteSettings
}

const ExternalScripts = ({ publicSettings }: ExternalScriptsProps) => {
  const gtmScriptUrl = publicSettings?.gtmScriptUrl

  const pageLoadEventId = useMemo(() => {
    const nanoid = customAlphabet('1234567890abcdef', 16)
    return nanoid()
  }, [])

  return (
    <>
      {!!gtmScriptUrl && (
        <>
          <Script id="google-tag-manager-variables" strategy="afterInteractive">
            {`
              window['dataLayer'] = window['dataLayer'] || []
              window['dataLayer'].push({ event_id: '${pageLoadEventId}' })
              window['dataLayer'].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
            `}
          </Script>

          <Script
            id={`google-tag-manager-${gtmScriptUrl}`}
            src={gtmScriptUrl}
            strategy="afterInteractive"
          />
        </>
      )}
    </>
  )
}

export default ExternalScripts
